<template>
  <div class="feature-request page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Feature Requests')">
      <template v-slot:buttons>
        <add-new-button v-permission="'change_featurerequest'" @click="newClick">
          <font-awesome-icon icon="plus-circle" class="icon"/>
          {{$t('Request New Feature')}}
        </add-new-button>
      </template>
    </page-header>
    <div class="card content-wrapper p-2">
      <FeatureRequestTable/>
    </div>
  </div>
</template>

<script>
  import AddNewButton from "../../core/components/common/AddNewButton";
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "../../core/components/page-header/PageHeader";
  import FeatureRequestTable from "@/modules/feature-request/FeatureRequestTable";
  import {SOURCE_FEATURE_REQUEST_TABLE} from "@/modules/constants";

  const {mapActions} = createNamespacedHelpers('featureRequest');
  export default {
    name: "FeatureRequest",
    components: {FeatureRequestTable, PageHeader, AddNewButton},
    methods: {
      ...mapActions(['showModal', 'updateTableSource']),
      newClick() {
        this.showModal({source: SOURCE_FEATURE_REQUEST_TABLE})
      }
    },
    async beforeMount() {
      await this.updateTableSource({source: 'featureRequest'});
    }
  }
</script>

<style lang="scss" scoped>
</style>

